/**
 * Settings kept on this device. Reads what was saved under `key`, keeping only values of the same type as the
 * defaults, so old or broken settings fall back to the defaults.
 */
export function loadSettings<T extends object>(key: string, defaults: T): T {
    try {
        const saved = JSON.parse(localStorage.getItem(key) ?? "{}") as Record<string, unknown>;
        const kept = Object.entries(saved).filter(([name, value]) => name in defaults && typeof value === typeof defaults[name as keyof T]);

        return { ...defaults, ...Object.fromEntries(kept) };
    } catch {
        return defaults;
    }
}

/** Keeps settings on this device. */
export function saveSettings(key: string, settings: unknown): void {
    try {
        localStorage.setItem(key, JSON.stringify(settings));
    } catch {
        // Not being able to remember it isn't worth bothering anyone about.
    }
}
